import { ActionCreator, Action } from 'redux';

export const setProjectData: ActionCreator<Action> = (data) => ({
    type: 'SET_PROJECT_DATA',
    data,
});

export const setSelectedMainStyle = (data) => ({
    type: 'SET_SELECTED_MAIN_STYLE',
    data,
});